export default "__VITE_ASSET__cQr5lkR6__"